import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({ scaleX, fill, outline, gradient }) {
  const randomGradientId1 = `_${useRandomId()}`
  const randomGradientId2 = `_${useRandomId()}`

  return (
    <g transform={`scale(${scaleX},1)`}>
      <path
        d="M14.4701 7.68531C14.4701 7.68531 8.61012 -0.764668 3.38012 1.33533C0.970116 2.30533 0.660116 4.9153 1.27012 7.2353C2.01012 10.0253 4.03012 12.6353 4.58012 14.4953C5.59012 17.9153 4.04012 25.6853 8.55012 26.8553C13.5801 28.1553 15.1501 20.3853 15.1501 20.3853L14.4701 7.68531Z"
        fill={fill}
        stroke={outline}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M5.71996 12.2353C5.71996 12.2353 2.71996 6.85531 3.87996 4.80531C5.02996 2.76531 10.02 5.1153 11.89 18.1053"
        fill={`url(#${randomGradientId1})`}
      />
      <path
        d="M5.71005 12.2352C4.54005 10.4452 3.50005 8.53524 3.20005 6.26524C3.16005 5.69524 3.18005 5.05524 3.56005 4.45524C3.75005 4.15524 4.06005 3.9052 4.41005 3.7852C4.76005 3.6652 5.12005 3.6652 5.45005 3.7252C6.73005 4.0452 7.55005 4.93522 8.23005 5.80522C9.56005 7.60522 10.35 9.67523 10.9 11.7552C11.45 13.8452 11.77 15.9752 11.88 18.1052C11.38 16.0252 10.86 13.9652 10.18 11.9652C9.47005 9.99519 8.67005 8.0252 7.43005 6.4052C6.82005 5.6252 6.06005 4.86521 5.24005 4.66521C4.84005 4.58521 4.51005 4.66524 4.30005 4.95524C4.08005 5.24524 4.01005 5.73519 4.01005 6.21519C4.02005 7.20519 4.29005 8.23521 4.61005 9.23521C4.93005 10.2552 5.31005 11.2452 5.71005 12.2352Z"
        fill={outline}
      />
      <path
        d="M71.7904 7.68531C71.7904 7.68531 77.6503 -0.764668 82.8803 1.33533C85.2903 2.30533 85.6003 4.9153 84.9903 7.2353C84.2503 10.0253 82.2304 12.6353 81.6804 14.4953C80.6704 17.9153 82.2204 25.6853 77.7104 26.8553C72.6803 28.1553 71.1104 20.3853 71.1104 20.3853L71.7904 7.68531Z"
        fill={fill}
        stroke={outline}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M80.5499 12.2353C80.5499 12.2353 83.5499 6.85531 82.3899 4.80531C81.2399 2.76531 76.2499 5.1153 74.3799 18.1053"
        fill={`url(#${randomGradientId2})`}
      />
      <path
        d="M80.5501 12.2353C80.9501 11.2453 81.3401 10.2553 81.6401 9.24527C81.9601 8.24527 82.2301 7.21525 82.2401 6.22525C82.2401 5.74525 82.1701 5.25524 81.9501 4.96524C81.7401 4.67524 81.4201 4.59526 81.0101 4.67526C80.1901 4.87526 79.4301 5.63525 78.8201 6.41525C77.5901 8.03525 76.7801 10.0052 76.0701 11.9753C75.3901 13.9653 74.8801 16.0353 74.3701 18.1153C74.4901 15.9753 74.8101 13.8553 75.3501 11.7653C75.9001 9.68529 76.6901 7.62528 78.0201 5.81528C78.7001 4.94528 79.5201 4.05526 80.8001 3.73526C81.1201 3.67526 81.4901 3.66526 81.8401 3.79526C82.1901 3.91526 82.5001 4.16524 82.6901 4.46524C83.0701 5.06524 83.0901 5.7053 83.0501 6.2753C82.7601 8.5353 81.7201 10.4453 80.5501 12.2353Z"
        fill={outline}
      />
      <defs>
        <radialGradient
          id={randomGradientId1}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(8.6328 4.91575) rotate(154.767) scale(9.28145 16.0402)"
        >
          <stop stopColor={gradient[0]} />
          <stop offset="1" stopColor={gradient[1]} />
        </radialGradient>
        <radialGradient
          id={randomGradientId2}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(77.5472 4.9387) rotate(25.2325) scale(9.28145 16.0402)"
        >
          <stop stopColor={gradient[0]} />
          <stop offset="1" stopColor={gradient[1]} />
        </radialGradient>
      </defs>
    </g>
  )
}
